"use client";

import { cn } from "@/lib/utils";
import { ChevronRightIcon, LoaderCircleIcon, MapPinIcon } from "lucide-react";
import { useTranslations } from "next-intl";

function areaLabel(count: number) {
  if (count === 1) return "1 listing without an exact address";
  return `${count.toLocaleString()} listings without an exact address`;
}

const shell =
  "absolute top-3 left-1/2 z-10 flex h-11 max-w-[calc(100vw-1.5rem)] -translate-x-1/2 items-center gap-2 rounded-full bg-card px-4 text-sm font-medium text-foreground shadow-lg sm:h-9";

export function MapUnpinnedControl({
  areaCount,
  isUpdating,
  onShow,
}: {
  areaCount: number;
  isUpdating: boolean;
  onShow: () => void;
}) {
  const t = useTranslations();

  if (areaCount <= 0 && !isUpdating) return null;

  if (areaCount <= 0) {
    return (
      <output className={cn(shell, "text-muted-foreground")}>
        <LoaderCircleIcon className="h-4 w-4 animate-spin" />
        {t("common.updating")}
      </output>
    );
  }

  return (
    <button
      type="button"
      className={cn(
        shell,
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-foreground",
      )}
      onClick={onShow}
    >
      {isUpdating ? (
        <LoaderCircleIcon className="h-4 w-4 shrink-0 animate-spin text-muted-foreground" />
      ) : (
        <MapPinIcon className="h-4 w-4 shrink-0 text-emerald-700" />
      )}
      <span className="min-w-0 truncate">{areaLabel(areaCount)}</span>
      <span className="shrink-0 text-muted-foreground">Show</span>
      <ChevronRightIcon className="h-4 w-4 text-muted-foreground" aria-hidden />
    </button>
  );
}
